import { render, staticRenderFns } from "./WhatsappBusinessChannels.vue?vue&type=template&id=b0fca5e2&scoped=true"
import script from "./WhatsappBusinessChannels.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessChannels.vue?vue&type=script&lang=js"
import style0 from "./WhatsappBusinessChannels.vue?vue&type=style&index=0&id=b0fca5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fca5e2",
  null
  
)

export default component.exports